export default "__VITE_ASSET__DudhOVDg__"